<template>
  <div class="exclusiveActivitiesdetails align-center-main">
    <div class="header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/parkCompleteSet' }">{{childName}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/parkCompleteSet/exclusiveActivities' }">{{ serviceMsg.serviceName }}</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="m_t20" v-loading="loading">
      <div class="box2 boxShadow">
        <img :src="welfareDetails.banner" alt="" class="in_b b_img">
        <div class="content">
          <h3 class="m_t30 titel"> {{welfareDetails.title}}</h3>
          <p class="youhui"> 园区用户专享：{{welfareDetails.discountLimit}}</p>
          <p class="m_t10 "> 福利来自：{{welfareDetails.providerName}}</p>
          <p class=" "> 发放数量：{{welfareDetails.showNum}}</p>
          <p class=" "> 有效期限：{{welfareDetails.beginTime | DateFilter('yyyy-MM-dd hh:mm')}} 至 {{welfareDetails.endTime | DateFilter('yyyy-MM-dd hh:mm')}}</p>
          <div class="BMbtn" @click="signUp">领取</div>
          <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg='tips.tipsMsg'></SubmitSuccess>
        </div>
      </div>
      <div class="m_t20 boxShadow article">
        <p class="til">产品介绍</p>
        <div v-html="welfareDetails.content" ref="text"></div>
      </div>
    </div>
    <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      submitSuccessFlag: false,
      showLogin: false,
      loading: true,
      tips: {
        tipsMsg: '领取成功！',
      },
      welfareDetails:{},
      serviceMsg: {},
      childName: '',
    }
  },
  methods:{
    signUp() {
      if (!this.token) {
        this.showLogin = true;
      } else if (this.welfareDetails.linkUrl) {
        window.location.href = this.welfareDetails.linkUrl;
      } else {
        this.receive();
      }
    },
    receive() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/added/welfare/order`, {
        parkId: this.currentParkId,
        welfareId: this.$route.params.exclusiveActivitiesdetailsId,
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.submitSuccessFlag = true;
          this.tips.tipsMsg = '领取成功！';
        } else if (res.resCode === '12806') {
          this.submitSuccessFlag = true;
          this.tips.tipsMsg = '该功能仅限已入驻园区的企业用户使用，请联系您的企业管理员。未入住园区的企业，请使用PC端在线提交入驻申请。';
        } else {
          this.submitSuccessFlag = true;
          this.tips.tipsMsg = res.resDesc;
        }
      });
    },
    exclusiveDetails() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/welfare/info/detail`,{
        welfareId: this.$route.params.exclusiveActivitiesdetailsId,
        parkId: this.currentParkId,
      }).then((res) =>{
        if (res.data.resCode === '10000') {
          this.loading = false;
          this.welfareDetails = res.data.resData;
        }
      });
    },
  },
  updated() {
    const imgs = this.$refs.text.querySelectorAll('img');
    imgs.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  },
  created() {
    this.exclusiveDetails();
    if (this.parkServiceList.length) {
      const obj = this.parkServiceList.find((val) => {
        return val.serviceFlag === 6;
      });
      this.childName = obj.serviceName;
      this.serviceMsg = obj.children.find((val) => {
        return val.type === 14;
      });
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user', 'parkServiceList']),
  },
}
</script>
<style lang="scss" scoped>
@import "~@scss";

.exclusiveActivitiesdetails{
  padding-bottom: 18px;
}
.box2{
  height: auto;
  display: flex;
  margin-bottom: 20px;
  background-color: #fff;
  position: relative;
}
.b_img{
  width: 400px;
  height: 300px;
}
.content{
  flex: 1;
  box-sizing: border-box;
  padding: 0 0 0 20px;
  p{
    color: #666;
    line-height: 1.5;
  }
  .youhui{
    color: #de2c32;
    font-size: 16px;
    margin-top: 10px;
    font-weight: 600;
  }
  .submit-success{
    right: 40%;
    bottom: 40%;
    text-align: center;
  }
}
.BMbtn{
  width: 100px;
  height: 32px;
  border-radius: 7px;
  background-color: #D9262c;
  color: #fff;
  line-height: 32px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  margin-top: 24px;
  letter-spacing:2px;
}
.article{
  box-sizing: border-box;
  padding: 40px;
  background-color: #fff;
  .til{
    font-size: 18px;
    font-weight: bold;
  }
}
.m_l40{
  margin-left: 40px;
}
.m_l20{
  margin-left: 20px;
}
.m_t30{
  margin-top: 30px;
}
.m_t20{
  margin-top: 20px;
}
.m_t10{
  margin-top: 10px;
}
.titel{
  font-size: 26px;
  padding-right: 30px;
  font-weight: 600;
  @include lines-ellipsis;
}
.in_b{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/parkCompleteSet/completeSetdetails/ExclusiveActivitiesdetails.vue